import angular from 'angular';
import config from 'app/config';

import { appService } from './app.service';
import { pageService } from './page.service';
import { userService } from './user.service';

export default angular
  .module(`${config.appName}.commonServices`, [])
  .service('appService', appService)
  .service('pageService', pageService)
  .service('userService', userService)
  .name;
